module.exports = __webpack_public_path__ + "img/lane.e991b0b2.jpeg";